"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterImpressionTrack = exports.FilterCarouselImpressionTrack = exports.FilterImpressionTrack_GeofilterType = void 0;
/* eslint-disable */
const unlockable_attachment_impression_1 = require("./unlockable_attachment_impression");
const snap_creation_info_1 = require("./snap_creation_info");
const device_info_1 = require("./device/device_info");
const ad_flag_data_1 = require("./ad_flag_data");
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const wrappers_1 = require("../../../google/protobuf/wrappers");
var FilterImpressionTrack_GeofilterType;
(function (FilterImpressionTrack_GeofilterType) {
    FilterImpressionTrack_GeofilterType[FilterImpressionTrack_GeofilterType["UNKNOWN_FILTER_TYPE"] = 0] = "UNKNOWN_FILTER_TYPE";
    FilterImpressionTrack_GeofilterType[FilterImpressionTrack_GeofilterType["GEO_FILTER"] = 1] = "GEO_FILTER";
    FilterImpressionTrack_GeofilterType[FilterImpressionTrack_GeofilterType["BITMOJI_FILTER"] = 2] = "BITMOJI_FILTER";
    FilterImpressionTrack_GeofilterType[FilterImpressionTrack_GeofilterType["FRAME_FILTER"] = 3] = "FRAME_FILTER";
    FilterImpressionTrack_GeofilterType[FilterImpressionTrack_GeofilterType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(FilterImpressionTrack_GeofilterType = exports.FilterImpressionTrack_GeofilterType || (exports.FilterImpressionTrack_GeofilterType = {}));
function createBaseFilterCarouselImpressionTrack() {
    return {
        snapCreationInfo: undefined,
        snapSessionId: new Uint8Array(),
        carouselSize: undefined,
        filterImpressions: [],
        deviceInfo: undefined,
        snapSessionIdString: "",
    };
}
exports.FilterCarouselImpressionTrack = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.snapCreationInfo !== undefined) {
            snap_creation_info_1.SnapCreationInfo.encode(message.snapCreationInfo, writer.uint32(10).fork()).ldelim();
        }
        if (message.snapSessionId.length !== 0) {
            writer.uint32(18).bytes(message.snapSessionId);
        }
        if (message.carouselSize !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.carouselSize }, writer.uint32(26).fork()).ldelim();
        }
        for (const v of message.filterImpressions) {
            exports.FilterImpressionTrack.encode(v, writer.uint32(34).fork()).ldelim();
        }
        if (message.deviceInfo !== undefined) {
            device_info_1.DeviceInfo.encode(message.deviceInfo, writer.uint32(42).fork()).ldelim();
        }
        if (message.snapSessionIdString !== "") {
            writer.uint32(50).string(message.snapSessionIdString);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFilterCarouselImpressionTrack();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.snapCreationInfo = snap_creation_info_1.SnapCreationInfo.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.snapSessionId = reader.bytes();
                    break;
                case 3:
                    message.carouselSize = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 4:
                    message.filterImpressions.push(exports.FilterImpressionTrack.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.deviceInfo = device_info_1.DeviceInfo.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.snapSessionIdString = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseFilterCarouselImpressionTrack();
        message.snapCreationInfo =
            object.snapCreationInfo !== undefined && object.snapCreationInfo !== null
                ? snap_creation_info_1.SnapCreationInfo.fromPartial(object.snapCreationInfo)
                : undefined;
        message.snapSessionId = object.snapSessionId ?? new Uint8Array();
        message.carouselSize = object.carouselSize ?? undefined;
        message.filterImpressions =
            object.filterImpressions?.map((e) => exports.FilterImpressionTrack.fromPartial(e)) || [];
        message.deviceInfo =
            object.deviceInfo !== undefined && object.deviceInfo !== null
                ? device_info_1.DeviceInfo.fromPartial(object.deviceInfo)
                : undefined;
        message.snapSessionIdString = object.snapSessionIdString ?? "";
        return message;
    },
};
function createBaseFilterImpressionTrack() {
    return {
        geofilterId: undefined,
        totalSwipedViewMillis: undefined,
        encGeoData: new Uint8Array(),
        swipedOverCount: undefined,
        withSnapSend: undefined,
        withStoryPost: undefined,
        withMemoriesSave: undefined,
        filterIndexPos: undefined,
        geofilterType: 0,
        encryptedAdTrackData: new Uint8Array(),
        filterGeofilterIndexPos: undefined,
        firstSeenTimestamp: undefined,
        encryptedSponsoredUnlockableTargetingInfoData: new Uint8Array(),
        rankingId: new Uint8Array(),
        rankingData: new Uint8Array(),
        snapSendRecipientCount: undefined,
        snapSendCount: undefined,
        storyPostCount: undefined,
        memoriesSaveCount: undefined,
        captureTimeMillis: undefined,
        postCaptureTimeMillis: undefined,
        maxSwipeTimeMillis: undefined,
        maxContinuousTimeMillis: undefined,
        totalTimeMillis: undefined,
        reactionTimestamp: undefined,
        shareTimestamp: undefined,
        swipeUpTimestamp: undefined,
        saveTimestamp: undefined,
        screenshotTimestamp: undefined,
        attachmentImpression: undefined,
        withAttachmentOpen: undefined,
        attachmentType: 0,
        adFlagData: undefined,
    };
}
exports.FilterImpressionTrack = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.geofilterId !== undefined) {
            wrappers_1.StringValue.encode({ value: message.geofilterId }, writer.uint32(10).fork()).ldelim();
        }
        if (message.totalSwipedViewMillis !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.totalSwipedViewMillis }, writer.uint32(18).fork()).ldelim();
        }
        if (message.encGeoData.length !== 0) {
            writer.uint32(26).bytes(message.encGeoData);
        }
        if (message.swipedOverCount !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.swipedOverCount }, writer.uint32(34).fork()).ldelim();
        }
        if (message.withSnapSend !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.withSnapSend }, writer.uint32(42).fork()).ldelim();
        }
        if (message.withStoryPost !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.withStoryPost }, writer.uint32(50).fork()).ldelim();
        }
        if (message.withMemoriesSave !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.withMemoriesSave }, writer.uint32(58).fork()).ldelim();
        }
        if (message.filterIndexPos !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.filterIndexPos }, writer.uint32(66).fork()).ldelim();
        }
        if (message.geofilterType !== 0) {
            writer.uint32(72).int32(message.geofilterType);
        }
        if (message.encryptedAdTrackData.length !== 0) {
            writer.uint32(82).bytes(message.encryptedAdTrackData);
        }
        if (message.filterGeofilterIndexPos !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.filterGeofilterIndexPos }, writer.uint32(90).fork()).ldelim();
        }
        if (message.firstSeenTimestamp !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.firstSeenTimestamp }, writer.uint32(98).fork()).ldelim();
        }
        if (message.encryptedSponsoredUnlockableTargetingInfoData.length !== 0) {
            writer
                .uint32(106)
                .bytes(message.encryptedSponsoredUnlockableTargetingInfoData);
        }
        if (message.rankingId.length !== 0) {
            writer.uint32(114).bytes(message.rankingId);
        }
        if (message.rankingData.length !== 0) {
            writer.uint32(122).bytes(message.rankingData);
        }
        if (message.snapSendRecipientCount !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.snapSendRecipientCount }, writer.uint32(130).fork()).ldelim();
        }
        if (message.snapSendCount !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.snapSendCount }, writer.uint32(138).fork()).ldelim();
        }
        if (message.storyPostCount !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.storyPostCount }, writer.uint32(146).fork()).ldelim();
        }
        if (message.memoriesSaveCount !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.memoriesSaveCount }, writer.uint32(154).fork()).ldelim();
        }
        if (message.captureTimeMillis !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.captureTimeMillis }, writer.uint32(162).fork()).ldelim();
        }
        if (message.postCaptureTimeMillis !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.postCaptureTimeMillis }, writer.uint32(170).fork()).ldelim();
        }
        if (message.maxSwipeTimeMillis !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.maxSwipeTimeMillis }, writer.uint32(178).fork()).ldelim();
        }
        if (message.maxContinuousTimeMillis !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.maxContinuousTimeMillis }, writer.uint32(186).fork()).ldelim();
        }
        if (message.totalTimeMillis !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.totalTimeMillis }, writer.uint32(194).fork()).ldelim();
        }
        if (message.reactionTimestamp !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.reactionTimestamp }, writer.uint32(202).fork()).ldelim();
        }
        if (message.shareTimestamp !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.shareTimestamp }, writer.uint32(210).fork()).ldelim();
        }
        if (message.swipeUpTimestamp !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.swipeUpTimestamp }, writer.uint32(218).fork()).ldelim();
        }
        if (message.saveTimestamp !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.saveTimestamp }, writer.uint32(226).fork()).ldelim();
        }
        if (message.screenshotTimestamp !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.screenshotTimestamp }, writer.uint32(234).fork()).ldelim();
        }
        if (message.attachmentImpression !== undefined) {
            unlockable_attachment_impression_1.UnlockableAttachmentImpression.encode(message.attachmentImpression, writer.uint32(242).fork()).ldelim();
        }
        if (message.withAttachmentOpen !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.withAttachmentOpen }, writer.uint32(250).fork()).ldelim();
        }
        if (message.attachmentType !== 0) {
            writer.uint32(256).int32(message.attachmentType);
        }
        if (message.adFlagData !== undefined) {
            ad_flag_data_1.AdFlagData.encode(message.adFlagData, writer.uint32(266).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFilterImpressionTrack();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.geofilterId = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 2:
                    message.totalSwipedViewMillis = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 3:
                    message.encGeoData = reader.bytes();
                    break;
                case 4:
                    message.swipedOverCount = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 5:
                    message.withSnapSend = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 6:
                    message.withStoryPost = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 7:
                    message.withMemoriesSave = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 8:
                    message.filterIndexPos = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 9:
                    message.geofilterType = reader.int32();
                    break;
                case 10:
                    message.encryptedAdTrackData = reader.bytes();
                    break;
                case 11:
                    message.filterGeofilterIndexPos = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 12:
                    message.firstSeenTimestamp = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 13:
                    message.encryptedSponsoredUnlockableTargetingInfoData =
                        reader.bytes();
                    break;
                case 14:
                    message.rankingId = reader.bytes();
                    break;
                case 15:
                    message.rankingData = reader.bytes();
                    break;
                case 16:
                    message.snapSendRecipientCount = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 17:
                    message.snapSendCount = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 18:
                    message.storyPostCount = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 19:
                    message.memoriesSaveCount = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 20:
                    message.captureTimeMillis = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 21:
                    message.postCaptureTimeMillis = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 22:
                    message.maxSwipeTimeMillis = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 23:
                    message.maxContinuousTimeMillis = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 24:
                    message.totalTimeMillis = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 25:
                    message.reactionTimestamp = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 26:
                    message.shareTimestamp = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 27:
                    message.swipeUpTimestamp = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 28:
                    message.saveTimestamp = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 29:
                    message.screenshotTimestamp = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 30:
                    message.attachmentImpression = unlockable_attachment_impression_1.UnlockableAttachmentImpression.decode(reader, reader.uint32());
                    break;
                case 31:
                    message.withAttachmentOpen = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 32:
                    message.attachmentType = reader.int32();
                    break;
                case 33:
                    message.adFlagData = ad_flag_data_1.AdFlagData.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseFilterImpressionTrack();
        message.geofilterId = object.geofilterId ?? undefined;
        message.totalSwipedViewMillis = object.totalSwipedViewMillis ?? undefined;
        message.encGeoData = object.encGeoData ?? new Uint8Array();
        message.swipedOverCount = object.swipedOverCount ?? undefined;
        message.withSnapSend = object.withSnapSend ?? undefined;
        message.withStoryPost = object.withStoryPost ?? undefined;
        message.withMemoriesSave = object.withMemoriesSave ?? undefined;
        message.filterIndexPos = object.filterIndexPos ?? undefined;
        message.geofilterType = object.geofilterType ?? 0;
        message.encryptedAdTrackData =
            object.encryptedAdTrackData ?? new Uint8Array();
        message.filterGeofilterIndexPos =
            object.filterGeofilterIndexPos ?? undefined;
        message.firstSeenTimestamp = object.firstSeenTimestamp ?? undefined;
        message.encryptedSponsoredUnlockableTargetingInfoData =
            object.encryptedSponsoredUnlockableTargetingInfoData ?? new Uint8Array();
        message.rankingId = object.rankingId ?? new Uint8Array();
        message.rankingData = object.rankingData ?? new Uint8Array();
        message.snapSendRecipientCount = object.snapSendRecipientCount ?? undefined;
        message.snapSendCount = object.snapSendCount ?? undefined;
        message.storyPostCount = object.storyPostCount ?? undefined;
        message.memoriesSaveCount = object.memoriesSaveCount ?? undefined;
        message.captureTimeMillis = object.captureTimeMillis ?? undefined;
        message.postCaptureTimeMillis = object.postCaptureTimeMillis ?? undefined;
        message.maxSwipeTimeMillis = object.maxSwipeTimeMillis ?? undefined;
        message.maxContinuousTimeMillis =
            object.maxContinuousTimeMillis ?? undefined;
        message.totalTimeMillis = object.totalTimeMillis ?? undefined;
        message.reactionTimestamp = object.reactionTimestamp ?? undefined;
        message.shareTimestamp = object.shareTimestamp ?? undefined;
        message.swipeUpTimestamp = object.swipeUpTimestamp ?? undefined;
        message.saveTimestamp = object.saveTimestamp ?? undefined;
        message.screenshotTimestamp = object.screenshotTimestamp ?? undefined;
        message.attachmentImpression =
            object.attachmentImpression !== undefined &&
                object.attachmentImpression !== null
                ? unlockable_attachment_impression_1.UnlockableAttachmentImpression.fromPartial(object.attachmentImpression)
                : undefined;
        message.withAttachmentOpen = object.withAttachmentOpen ?? undefined;
        message.attachmentType = object.attachmentType ?? 0;
        message.adFlagData =
            object.adFlagData !== undefined && object.adFlagData !== null
                ? ad_flag_data_1.AdFlagData.fromPartial(object.adFlagData)
                : undefined;
        return message;
    },
};
//# sourceMappingURL=filter_impression_track.js.map